<template>
  <div v-if="src" class="lightbox-overlay" @click="close">
    <div class="lightbox-content" @click.stop>
      <button v-show="loaded" class="lightbox-close" @click="close" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
      <img
        :src="src"
        :alt="alt"
        @load="loaded = true"
        :class="{ 'lightbox-img-loaded': loaded }"
      />
      <div v-if="!loaded" class="lightbox-loading">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Lightbox',
  props: {
    src: { type: String, default: null },
    alt: { type: String, default: '' }
  },
  data() {
    return { loaded: false };
  },
  watch: {
    src(val) {
      this.loaded = false;
      if (val) {
        document.addEventListener('keydown', this.onKey);
      } else {
        document.removeEventListener('keydown', this.onKey);
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKey);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKey(e) {
      if (e.key === 'Escape') this.close();
    }
  }
};
</script>

<style scoped>
.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  cursor: pointer;
}

.lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  cursor: default;
}

.lightbox-content img {
  max-width: 100%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.lightbox-content img.lightbox-img-loaded {
  opacity: 1;
}

.lightbox-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 2.5rem;
}

.lightbox-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 2rem;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.2s ease;
  z-index: 1;
}

.lightbox-close:hover {
  color: #e74c3c;
}
</style>
